import { render, staticRenderFns } from "./giveGift.vue?vue&type=template&id=4adcf1c0&"
import script from "./giveGift.vue?vue&type=script&lang=js&"
export * from "./giveGift.vue?vue&type=script&lang=js&"
import style0 from "./giveGift.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports